var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNarrowUp0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53033 2.46967C9.23744 2.17678 8.76256 2.17678 8.46967 2.46967L3.96967 6.96967C3.67678 7.26256 3.67678 7.73744 3.96967 8.03033C4.26256 8.32322 4.73744 8.32322 5.03033 8.03033L8.25 4.81066L8.25 15C8.25 15.4142 8.58579 15.75 9 15.75C9.41421 15.75 9.75 15.4142 9.75 15L9.75 4.81066L12.9697 8.03033C13.2626 8.32322 13.7374 8.32322 14.0303 8.03033C14.3232 7.73744 14.3232 7.26256 14.0303 6.96967L9.53033 2.46967Z",
    fill: "#141922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowUp0);
export default __webpack_public_path__ + "static/media/arrow-narrow-up0.ff9d2de8e95aef2353fa6c6c529f9c1c.svg";
export { ForwardRef as ReactComponent };